export default __webpack_public_path__ + "static/media/cv.912e7d2e.svg";